const cardsValuab = document.querySelectorAll('.card-valuab');

function initCardValuabClick() {
  const delay = 500;

  let canClick = true;

  cardsValuab.forEach((card, index) => {
    const cardContent = card.querySelector('.card-valuab__content');
    if (!cardContent) return;

    card.style.zIndex = index + 1;

    card.addEventListener('click', () => {
      if (!canClick) return;
      canClick = false;

      const isActive = cardContent.classList.contains('is-active');

      cardsValuab.forEach(otherCard => {
        const otherContent = otherCard.querySelector('.card-valuab__content');
        if (
          otherContent &&
          otherContent !== cardContent &&
          otherContent.classList.contains('is-active')
        ) {
          otherContent.classList.add('to-right');

          setTimeout(() => {
            otherContent.classList.remove('is-active');
          }, delay / 2);

          setTimeout(() => {
            otherContent.classList.remove('is-tran');
            otherContent.classList.remove('to-right');
          }, delay);
        }
      });

      cardContent.classList.add('to-right');

      setTimeout(() => {
        cardContent.classList.toggle('is-active', !isActive);
      }, delay / 2);

      setTimeout(() => {
        cardContent.classList.toggle('is-tran', !isActive);
        cardContent.classList.remove('to-right');
      }, delay);

      setTimeout(() => {
        canClick = true;
      }, delay * 2);
    });
  });
}

document.addEventListener('DOMContentLoaded', initCardValuabClick);
